/**
 * ProduccionAdmin — filamentos, impresoras, calendario y configuración de
 * producción (MVP-07). Mismo patrón de pestañas que `EnviosAdmin.jsx`
 * (MVP-02C): cada pestaña llama directamente a su endpoint dedicado, sin
 * reimplementar reglas que ya viven en `fulfillment/services.py`. Ninguna
 * acción de esta pantalla controla una impresora física.
 */
import { useState } from "react";
import { Boxes, CalendarClock, Settings, Sparkles } from "lucide-react";

import FilamentosSection from "./sections/FilamentosSection.jsx";
import ImpresorasSection from "./sections/ImpresorasSection.jsx";
import ReservasSection from "./sections/ReservasSection.jsx";
import ConfiguracionSection from "./sections/ConfiguracionSection.jsx";

const TABS = [
    { id: "filamentos", label: "Filamentos", icon: Sparkles },
    { id: "impresoras", label: "Impresoras", icon: Boxes },
    { id: "reservas", label: "Calendario", icon: CalendarClock },
    { id: "configuracion", label: "Configuración", icon: Settings },
];

export default function ProduccionAdmin() {
    const [activeTab, setActiveTab] = useState("filamentos");

    return (
        <div className="p-4 lg:p-6 flex flex-col gap-4 h-full overflow-auto">
            <header className="flex items-center gap-3">
                <Boxes className="w-7 h-7 text-primary shrink-0" />
                <div>
                    <h1 className="text-xl font-bold">Producción</h1>
                    <p className="text-sm text-base-content/60">
                        Referencias de filamento, flota de impresoras y planificación de fabricación propia.
                        No sustituye la revisión manual de cada solicitud.
                    </p>
                </div>
            </header>

            <nav role="tablist" aria-label="Secciones de producción" className="tabs tabs-boxed flex-wrap">
                {TABS.map(({ id, label, icon: Icon }) => (
                    <button
                        key={id}
                        type="button"
                        role="tab"
                        aria-selected={activeTab === id}
                        className={`tab gap-1.5 ${activeTab === id ? "tab-active" : ""}`}
                        onClick={() => setActiveTab(id)}
                    >
                        <Icon className="w-3.5 h-3.5" />
                        {label}
                    </button>
                ))}
            </nav>

            <div className="flex-1 min-h-0">
                {activeTab === "filamentos" && <FilamentosSection />}
                {activeTab === "impresoras" && <ImpresorasSection />}
                {activeTab === "reservas" && <ReservasSection />}
                {activeTab === "configuracion" && <ConfiguracionSection />}
            </div>
        </div>
    );
}
